/*
 * Trinom Digital Pvt Ltd ("COMPANY") CONFIDENTIAL                             *
 * Copyright (c) 2025 Trinom Digital Pvt Ltd, All rights reserved              *
 *                                                                             *
 * NOTICE:  All information contained herein is, and remains the property      *
 * of COMPANY. The intellectual and technical concepts contained herein are    *
 * proprietary to COMPANY and may be covered by Indian and Foreign Patents,    *
 * patents in process, and are protected by trade secret or copyright law.     *
 * Dissemination of this information or reproduction of this material is       *
 * strictly forbidden unless prior written permission is obtained from         *
 * COMPANY. Access to the source code contained herein is hereby forbidden     *
 * to anyone except current COMPANY employees, managers or contractors who     *
 * have executed Confidentiality and Non-disclosure agreements explicitly      *
 * covering such access.                                                       *
 *                                                                             *
 * The copyright notice above does not evidence any actual or intended         *
 * publication or disclosure of this source code, which includes               *
 * information that is confidential and/or proprietary, and is a trade secret, *
 * of COMPANY. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC            *
 * PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE CODE        *
 * WITHOUT THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED,      *
 * AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE         *
 * RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES   *
 * NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS     *
 * CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,    *
 * IN WHOLE OR IN PART.                                                        *
 *                                                                             *
 * File: \src\services\chartService.js                                         *
 * Project: my-vuetify-app                                                     *
 * Created Date: Tuesday, March 25th 2025, 11:06:25 am                         *
 * Author: Renjith R T <renjith@codestax.ai>                                   *
 * -----                                                                       *
 * Last Modified: March 27th 2026, 6:48:49 pm                                  *
 * Modified By: Sudhirkumar                                                    *
 * -----                                                                       *
 * Any app that can be written in JavaScript,                                  *
 *     will eventually be written in JavaScript !!                             *
 * -----                                                                       *
 * HISTORY:                                                                    *
 * Date         By  Comments                                                   *
 * --------------------------------------------------------------------------- *
 */

import axios from 'axios';
import moment from "moment-timezone";

let BASE_URL = process.env.VUE_APP_BACKEND_URL;

export const getChartData = async (chartId, projectId, metric, dateFilter = null) => {
    try {

        // use moment.js to get the timezone
        const timezone = moment.tz.guess();
        
        if (dateFilter != null) {
            const response = await axios.get(`${BASE_URL}/chartData/${chartId}`, {
                params: { projectId, range: dateFilter, timezone }
            });


            const timestreamResponse = response.data.data; // Access the 'data' array

            // Extract labels (period) and data (dynamic metric value)
            const labels = timestreamResponse.map((item) => item.period);
            const data = timestreamResponse.map((item) => item[metric]); // Dynamically accessing metric
    
            return { labels, data };
        }

        const response = await axios.get(`${BASE_URL}/chartData/${chartId}`, {
            params: { projectId, timezone },
        });

        const timestreamResponse = response.data.data; // Access the 'data' array

        // Extract labels (period) and data (dynamic metric value)
        const labels = timestreamResponse.map((item) => item.period);
        const data = timestreamResponse.map((item) => item[metric]); // Dynamically accessing metric

        return { labels, data };
    } catch (error) {
        console.error('Error fetching chart data:', error);
        throw error;
    }
};